import React, { Component } from 'react';
import { onUnsubClick } from '../../../utils/helper'


class NoFooter extends Component {
    
    render() {
        return (
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <a href='' onClick={onUnsubClick} target="_blank">Avslutte abonnementet</a>
                <span style={{color: '#007bff', margin: '0px 10px'}}>|</span>
                <a href="mailto:no@content-clubs.com">Kontakt: no@content-clubs.com</a>
            </div>
        );
    }
}

export default NoFooter;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/nofooter.js